import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-thanks-dialogue',
  templateUrl: './thanks-dialogue.component.html',
  styleUrls: ['./thanks-dialogue.component.scss']
})
export class ThanksDialogueComponent implements OnInit {
  @ViewChild('thanksRef', { static: false }) thanksElement!: ElementRef;

  constructor(public dialogRef: MatDialogRef<ThanksDialogueComponent>) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
